import { useSearchParams } from 'react-router-dom';
import { Quotes } from '../../../components/Admin/Quotes';

const QuotesScreen = () => {
    const [searchParams] = useSearchParams();

    return (
        <div className="articles__edit">
            <Quotes params={searchParams} />
        </div>
    );
};

export default QuotesScreen;
